// Stato dei caricamenti dai servizi, condiviso dalle pagine admin
import axios from 'axios';

export type LoadStatus = 'idle' | 'loading' | 'ready' | 'error';
export type ErrorKind = 'network' | 'forbidden' | 'server';

export interface LoadState {
  status: LoadStatus;
  error?: ErrorKind;
}

export interface LoaderResult<T> {
  state: LoadState;
  data: T | null;
  retry: () => void;
}

export const IDLE: LoadState = { status: 'idle' };

// Il 401 lo gestisce già l'interceptor di api (refresh del token o login)
export const getErrorKind = (error: unknown): ErrorKind => {
  if (axios.isAxiosError(error)) {
    if (!error.response) return 'network';
    if (error.response.status === 403) return 'forbidden';
  }
  return 'server';
};
